import { ReturnableTypeEnum } from "./returnable-type";
import { StockInModeEnum } from "./stock-in-mode";

/**
 * Rules that several parts of the return form have to agree on. They were
 * duplicated across the form and both source pickers, which is how they drifted
 * (one picker still wrote the returnable type as a bare string).
 */

/**
 * A line starts out matching the return's own stock-in mode. PARTIAL is a
 * per-line decision, so a line under it defaults to coming back into stock.
 */
export const resolveInitialStockInMode = (stockInMode) =>
  stockInMode === StockInModeEnum.PARTIAL ? StockInModeEnum.FULL : stockInMode;

/**
 * Delivery-order returns are settled against the invoice that follows, so they
 * carry no prices of their own — and no expenses either.
 */
export const hasPricing = (returnableType) =>
  returnableType === ReturnableTypeEnum.SALES_INVOICE ||
  returnableType === ReturnableTypeEnum.NON_INVOICE;

export const supportsExpenses = (returnableType) =>
  returnableType !== ReturnableTypeEnum.DELIVERY_ORDER;
